import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
	invoiceNoContainer: {
		flexDirection: 'row',
		marginTop: 20,
		justifyContent: 'flex-end',
	},
	invoiceDateContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	invoiceDate: {
		fontSize: 12,
		fontStyle: 'bold',
	},
	label: {
		width: 60,
	},
});

const InvoiceNo = ({ invoice }) => {
	const { t, i18n } = useTranslation();
	return (
		<Fragment>
			<View style={styles.invoiceNoContainer}>
				{/* <Text style={styles.label}>Offer No:</Text> */}
				<Text style={styles.invoiceDate}>
					{t('offerNo')} {invoice.invoice_no}
				</Text>
			</View>
			<View style={styles.invoiceDateContainer}>
				{/* <Text style={styles.label}>Date: </Text> */}
				<Text>
					{t('date')}: {invoice.trans_date}
				</Text>
			</View>
			<View style={styles.invoiceDateContainer}>
				<Text>{t('kvkNo')}. 77838769</Text>
			</View>
			<View style={styles.invoiceDateContainer}>
				<Text>{t('mobile_1')}: 0623847001</Text>
			</View>
		</Fragment>
	);
};

export default InvoiceNo;
